export default "__VITE_ASSET__xFm49L5m__"